import { render, staticRenderFns } from "./PeriodProvider.vue?vue&type=template&id=6d0d1326&scoped=true&"
import script from "./PeriodProvider.vue?vue&type=script&lang=js&"
export * from "./PeriodProvider.vue?vue&type=script&lang=js&"
import style0 from "./PeriodProvider.vue?vue&type=style&index=0&id=6d0d1326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d1326",
  null
  
)

export default component.exports